import React from 'react';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { isIOS } from '../../hooks/useInstallPwa';

const mapStateToProps = () => ({});

const NotificationsBlocked = () => (
  <Box>
    <Typography variant="body2" gutterBottom>
      Vous avez refusé les notifications. Pour les activer,
      suivez ces étapes :
    </Typography>
    {isIOS ? (
      <Box component="ol" sx={{ pl: 2, mt: 1 }}>
        <Typography component="li" variant="body2">
          Ouvrez <strong>Réglages</strong> sur votre iPhone
        </Typography>
        <Typography component="li" variant="body2">
          Appuyez sur <strong>Notifications</strong>
        </Typography>
        <Typography component="li" variant="body2">
          Trouvez l&apos;application et activez les notifications
        </Typography>
      </Box>
    ) : (
      <Box component="ol" sx={{ pl: 2, mt: 1 }}>
        <Typography component="li" variant="body2">
          Ouvrez <strong>Paramètres</strong> sur votre téléphone
        </Typography>
        <Typography component="li" variant="body2">
          Appuyez sur <strong>Applications</strong> puis
          trouvez l&apos;application
        </Typography>
        <Typography component="li" variant="body2">
          Appuyez sur <strong>Notifications</strong> et activez-les
        </Typography>
      </Box>
    )}
  </Box>
);

export default connect(mapStateToProps)(NotificationsBlocked);
